import Component from '../../lib/component'
import { tns } from 'tiny-slider/src/tiny-slider.module'

export default class SlideshowComponent extends Component {
    static selector () {
        return '.slideshow'
    }

    constructor (opts) {
        super(opts)

        this.addFeaturesToClassName()

        this.windowInnerWidth = window.innerWidth

        this.items = parseFloat(this.props.items || 1)
        this.slideBy = parseFloat(this.props.slideBy || 1)

        this.touchThreshold = 15
        this.touchstartX = 0
        this.touchstartY = 0

        this.speed = this.getFeature('touch')
            ? 400
            : 600

        this.slider = tns({
            arrowKeys: true,
            autoHeight: true,
            autoWidth: true,
            container: this.getSlider(),
            controls: Boolean(this.getControls()),
            controlsContainer: this.getControls(),
            items: this.items,
            loop: false,
            mouseDrag: true,
            nav: Boolean(this.getNav()),
            navContainer: this.getNav(),
            preventScrollOnTouch: 'auto',
            slideBy: this.slideBy,
            speed: this.speed,
            touch: false,
            onInit: () => setTimeout(() => {
                this.listen()
            }, 17)
        })
    }

    listen () {
        this.on('resize:debounced', () =>
            setTimeout(() => this.onResizeDebounced(), 17))

        this.slider.events
            .on('indexChanged', () =>
                setTimeout(() => this.render(), 17))

        Array.from(this.getSlider().children)
            .forEach((el, i) => el
                .addEventListener('click', () =>
                    this.slider.goTo(i)))

        if (!this.getFeature('touch'))
            return

        this.getSlider()
            .addEventListener('touchstart', this.onTouchStart.bind(this))

        this.getSlider()
            .addEventListener('touchmove', this.onTouchEnd.bind(this))

        this.getSlider()
            .addEventListener('touchend', this.onTouchEnd.bind(this))
    }

    onTouchStart (e) {
        this.touchstartX = e.changedTouches[0].screenX
        this.touchstartY = e.changedTouches[0].screenY
    }

    onTouchEnd (e) {
        if (this.touchstartX === null)
            return

        const xDiff = e.changedTouches[0].screenX - this.touchstartX
        const yDiff = e.changedTouches[0].screenY - this.touchstartY

        const getDiffAmount = (diff) => diff < 0
            ? diff * -1
            : diff

        if (getDiffAmount(xDiff) < this.touchThreshold
                || getDiffAmount(yDiff) > getDiffAmount(xDiff))
            return

        const info = this.slider.getInfo()

        if ((xDiff > 0
                    && !info.index)
                || (xDiff < 0
                    && info.displayIndex === info.slideItems.length))
            return

        this.touchstartX = null
        this.touchstartY = null

        this.slider.goTo(xDiff < 0
            ? 'next'
            : 'prev')
    }

    onResizeDebounced () {
        if (!this.slider
                || !('goTo' in this.slider))
            return

        const sliderEl = this.getSlider()

        const isReset = sliderEl.clientWidth >= sliderEl.scrollWidth

        const isWidthChange = this.windowInnerWidth !== window.innerWidth

        if (!isReset
                && !isWidthChange)
            return

        this.windowInnerWidth = window.innerWidth

        const info = this.slider.getInfo()

        const index = isReset
            ? 0
            : info.index

        if (index)
            this.slider.goTo(index - 1)

        setTimeout(() => this.slider.goTo(index), 17)
    }

    getControls () {
        return this.el.querySelector('.slideshow-controls')
    }

    getNav () {
        return this.el.querySelector('.slideshow-nav')
    }

    getSlider () {
        return this.el.querySelector('.slideshow-slider')
    }

    render () {
        if (!('getInfo' in (this.slider || {})))
            return

        const info = this.slider.getInfo()

        const setIndexProp = () => {
            this.props.index = info.displayIndex
        }

        if (this.slideBy > 1
                && info.displayIndex === this.slideBy) {
            const prevIndex = parseFloat(this.props.index || 1)

            setIndexProp()

            return this.slider.goTo(prevIndex > info.displayIndex
                ? 'prev'
                : 'next')
        }

        setIndexProp()

        const isLast = info.displayIndex === info.slideItems.length

        const innerEl = this.getSlider().parentElement

        if (!innerEl.style.transition)
            innerEl.style.transition = `transform ${this.speed}ms`

        const isTransformX = isLast
            && !innerEl.style.transform

        const isResetTransformX = !isLast
            && innerEl.style.transform

        if (!isTransformX
                && !isResetTransformX)
            return

        if (isResetTransformX) {
            innerEl.style.transform = ''
            return
        }

        const itemStyles = window.getComputedStyle(
            info.slideItems[info.slideItems.length - 1])

        const transformX = (parseFloat(itemStyles.paddingRight) || 0)
            + (parseFloat(itemStyles.paddingLeft) || 0)

        innerEl.style.transform = `translate3d(${transformX}px, 0, 0)`
    }
}
